<template>
  <v-container fluid>
    <v-card>
      <v-treeview
        :items="items"
        item-text="name"
        :load-children="fetchDestinations"
        transition
      >
        <template slot="prepend" slot-scope="{ item }">
          <treeview-destinations-item-actions
            :item="item"
            @editItem="editItem"
            @createItem="createItem"
            @deleteItem="onDeleteItem"
          ></treeview-destinations-item-actions>
        </template>
      </v-treeview>
    </v-card>

    <confirmation-dialog
      :item="selectedDestination"
      :showDialog="showConfirmationDialog"
      @onConfirm="deleteItem"
      @onCloseDialog="closeConfirmationDialog"
    >
      <template slot="message">This will remove destination.</template>
    </confirmation-dialog>
    <destination-edit-dialog
      :show="destinationEditorDialog"
      @close="destinationEditorDialog = false"
      v-model="selectedDestination"
      @save="onSave"
    ></destination-edit-dialog>
    <div v-if="debug">{{ selectedDestination }}</div>
  </v-container>
</template>

<script>
import {
  ALL_DESTINATIONS_SEARCH_QUERY,
  DESTINATION_DELETE_MUTATION,
  DESTINATION_UPDATE_MUTATION,
  DESTINATION_CREATE_MUTATION,
} from "../../../../constants/graphql";
import TreeviewDestinationsItemActions from "./TreeviewDestinationsItemActions";
import ConfirmationDialog from "../../shared/ConfirmationDialog";
import Contents from "../../shared/contents/Contents";
import DestinationEditDialog from "./DestinationEditDialog";

export default {
  name: "TreeviewDestinations",
  components: {
    DestinationEditDialog,
    TreeviewDestinationsItemActions,
    ConfirmationDialog,
  },

  data() {
    return {
      debug: false,
      children: [],
      destinationEditorDialog: false,

      selectedDestination: {},
      editedDestination: {},
      currentParent: null,
      items: [
        {
          id: "",
          name: "Destinations",
          children: [],
        },
      ],
      showConfirmationDialog: false,
    };
  },

  methods: {
    fetchDestinations(item) {
      return this.$apollo
        .query({
          query: ALL_DESTINATIONS_SEARCH_QUERY,
          variables: {
            filter: {
              parent_id: item.id,
            },
          },
        })
        .then((data) => this.getGqlObjectsHandler(data, item))
        .catch((error) => console.log(error));
    },

    getGqlObjectsHandler(result, item) {
      item.children = result.data.destinations.edges.map((d) => ({
        ...d.node,
        children: [],
      }));
    },

    getGqlObjectsErrorHandler() {},

    deleteItem(item) {
      this.currentId = item.id;
      this.$apollo
        .mutate({
          mutation: DESTINATION_DELETE_MUTATION,
          variables: {
            id: item.id,
          },
        })
        .then(this.removeGqlObjectHandler, this.removeGqlObjectErrorHandler);
      this.closeConfirmationDialog();
    },

    removeGqlObjectHandler(result) {
      this.$store.dispatch("showAppSnackbar", { msg: "Destination removed." });
      this.deleteItemFromItems();
    },

    removeGqlObjectErrorHandler(err) {
      this.$store.dispatch("showAppSnackbar", {
        msg: err.graphQLErrors[0].message,
        color: "error",
      });
    },

    deleteItemFromItems() {
      if (this.items[0].children.length > 0) {
        this.seekAndDestroy(this.items[0].children);
      }
    },

    seekAndDestroy(children) {
      for (let i = 0; i < children.length; i++) {
        if (children[i].id == this.currentId) {
          children.splice(i, 1);
        } else if (children[i].children.length > 0) {
          this.seekAndDestroy(children[i].children);
        }
      }
    },
    findItem(children, id) {
      for (let i = 0; i < children.length; i++) {
        if (children[i].id == id) {
          return children[i];
        } else if (children[i].children.length > 0) {
          return this.findItem(children[i].children, id);
        }
      }
    },

    editItem(item) {
      this.selectedDestination = { ...item };
      this.editedDestination = item;
      this.destinationEditorDialog = true;
    },

    createItem(item) {
      if (item.children.length == 0) {
        this.fetchDestinations(item);
      }
      this.currentParent = item;
      this.selectedDestination = { parentId: item.id };
      this.destinationEditorDialog = true;
    },
    closeDialog() {
      this.selectedDestination = {};
      this.destinationEditorDialog = false;
    },

    closeConfirmationDialog() {
      this.selectedDestination = {};
      this.showConfirmationDialog = false;
    },

    onSave(payload) {
      const mutation = payload.id
        ? DESTINATION_UPDATE_MUTATION
        : DESTINATION_CREATE_MUTATION;
      this.$apollo
        .mutate({
          mutation: mutation,
          variables: { ...payload },
          update: this.updateCache(
            payload.id ? "updateDestination" : "createDestination"
          ),
        })
        .then((result) => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Destination saved",
            color: "success",
          });
          this.destinationEditorDialog = false;
          if (payload.id) {
            //handle update
            const item2update = this.findItem(
              this.items[0].children,
              payload.id
            );
            // console.log("edited item: ", this.editedDestination);
            //console.log("item to update", item2update);
            this.editedDestination.name = payload.name;
          } else {
            //handle creation
            this.currentParent.children.push({
              children: [],
              ...result.data.createDestination,
            });
          }
        })
        .catch((error) => {
          this.$store.dispatch("showAppSnackbar", {
            msg: errror,
            color: "danger",
          });
        });
    },
    updateCache(operation) {
      return (store, { data }) => {
        const query = {
          query: ALL_DESTINATIONS_SEARCH_QUERY,
        };
        try {
          const listData = store.readQuery(query);
          if (operation.indexOf("create") > -1) {
            listData.destinations.edges.push({
              node: data[operation],
              __typename: "DestinationEdge",
            });
          } else if (operation.indexOf("delete") > -1) {
            listData.destinations.edges = listData.destinations.edges.filter(
              (d) => d.node.id !== data[operation].id
            );
          }
          store.writeQuery({
            ...query,
            data: { ...listData },
          });
        } catch (error) {
          console.log(error);
        }
      };
    },
    onDeleteItem(item) {
      this.selectedDestination = item;
      this.showConfirmationDialog = true;
    },
  },
};
</script>
<style scoped>
.flexcard {
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/gt/admin/destinations/TreeviewDestinations.vue